import { defaultTheme, TableTheme } from '@medly-components/theme';

import colors from './colors';

export const table: TableTheme = {
    ...defaultTheme.table,
    borderColor: colors.grey[300],
    shadowColor: colors.grey[500],
    row: {
        ...defaultTheme.table.row,
        separatorColor: colors.grey[300],
        textColor: {
            odd: colors.darkBlue,
            even: colors.darkBlue,
            selected: colors.darkBlue,
            disabled: colors.grey[500]
        },
        fontVariant: 'body1'
    },
    header: {
        ...defaultTheme.table.header,
        fontVariant: 'h5',
        cell: {
            ...defaultTheme.table.header.cell,
            textColor: {
                ...defaultTheme.table.header.cell.textColor,
                default: colors.darkBlue
            }
        }
    }
};
